const angular = require('angular');
const app = angular.module('learn-directives');
var tuiImageEditorImport = require('../imports/tui-image-editor');

var blackTheme = {
  'common.bi.image': 'https://uicdn.toast.com/toastui/img/tui-image-editor-bi.png',
  'common.bisize.width': '251px',
  'common.bisize.height': '21px',
  'common.backgroundImage': '',
  'common.backgroundColor': '#fff',
  'common.border': '1px solid #c1c1c1',

  // header
  'header.backgroundImage': 'none',
  'header.backgroundColor': 'transparent',
  'header.border': '0px',

  // load button
  'loadButton.backgroundColor': '#fff',
  'loadButton.border': '1px solid #ddd',
  'loadButton.color': '#222',
  'loadButton.fontFamily': '\'Gotham Rounded SSm A\', \'Gotham Rounded SSm B\', sans-serif',
  'loadButton.fontSize': '12px',

  // download button
  'downloadButton.backgroundColor': '#fdba3b',
  'downloadButton.border': '1px solid #fdba3b',
  'downloadButton.color': '#fff',
  'downloadButton.fontFamily': '\'Gotham Rounded SSm A\', \'Gotham Rounded SSm B\', sans-serif',
  'downloadButton.fontSize': '12px',

  // main icons
  'menu.normalIcon.path': 'icon-d.svg',
  'menu.normalIcon.name': 'icon-d',
  'menu.activeIcon.path': 'icon-b.svg',
  'menu.activeIcon.name': 'icon-b',
  'menu.disabledIcon.path': 'icon-a.svg',
  'menu.disabledIcon.name': 'icon-a',
  'menu.hoverIcon.path': 'icon-c.svg',
  'menu.hoverIcon.name': 'icon-c',
  'menu.iconSize.width': '24px',
  'menu.iconSize.height': '24px',

  // submenu primary color
  'submenu.backgroundColor': 'transparent',
  'submenu.partition.color': '#e5e5e5',

  // submenu icons
  'submenu.normalIcon.path': 'icon-d.svg',
  'submenu.normalIcon.name': 'icon-d',
  'submenu.activeIcon.path': 'icon-b.svg',
  'submenu.activeIcon.name': 'icon-b',
  'submenu.iconSize.width': '32px',
  'submenu.iconSize.height': '32px',

  // submenu labels
  'submenu.normalLabel.color': '#858585',
  'submenu.normalLabel.fontWeight': 'normal',
  'submenu.activeLabel.color': '#000000',
  'submenu.activeLabel.fontWeight': 'normal',

  // checkbox style
  'checkbox.border': '1px solid #ccc',
  'checkbox.backgroundColor': '#fff',

  // rango style
  'range.pointer.color': self.brandColor,
  'range.bar.color': '#858585',
  'range.subbar.color': self.brandColor,

  'range.disabledPointer.color': '#d3d3d3',
  'range.disabledBar.color': 'rgba(85,85,85,0.06)',
  'range.disabledSubbar.color': 'rgba(51,51,51,0.2)',

  'range.value.color': '#858585',
  'range.value.fontWeight': 'normal',
  'range.value.fontSize': '11px',
  'range.value.border': '0',
  'range.value.backgroundColor': '#858585',
  'range.title.color': '#858585',
  'range.title.fontWeight': 'lighter',

  // colorpicker style
  'colorpicker.button.border': '0px',
  'colorpicker.title.color': '#858585'
};

/**
 * Defines the user overview component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('presentationImage', ['Application', 'S3Uploads', 'Upload', function(Application, S3Uploads, Upload) {
  return {
    scope: {
      editSlide: '=',
      cancel: '&',
      add: '&'
    },
    template: require('../../templates/directives/presentation-image.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.image;
      self.imageData = {};
      self.settings = {
        imageName: null,
        image: null,
        loading: false,
        createLoading: false,
        fileName: null,
        percent: 0,
        makeProgress: function(percent) {
          return {
            'width': percent + '%'
          };
        },
        getBackground: function () {
          if (!self.image) {
            return;
          }
          return self.image;
        },
        editImage: function() {
          // Set timeouts are required to trick the watch
          self.settings.image = '';
          setTimeout(function() {
            self.settings.image = self.image;
            $scope.$apply();
          }, 0);
          return;
        }
      };

      self.editInit = async function(imageUrl) {
        blackTheme['common.backgroundImage'] = Application.tuiBgImage;
        const tuiImageEditorModule = await tuiImageEditorImport.importModule();
        const ImageEditor = tuiImageEditorModule.default;
        self.editInstance = new ImageEditor(document.querySelector('#card-editor'), {
          usageStatistics: false,
          includeUI: {
            loadImage: {
              path: imageUrl,
              name: 'SampleImage'
            },
            menu: ['filter', 'crop', 'flip', 'rotate'],
            theme: blackTheme,
            menuBarPosition: 'bottom'
          },
          cssMaxWidth: (document.documentElement.clientWidth - 200 ),
          cssMaxHeight: (document.documentElement.clientHeight - 200 ),
          selectionStyle: {
            borderColor: 'white',
            cornerColor: self.brandColor,
            cornerSize: 40,
            rotatingPointOffset: 100,
            transparentCorners: false
          }
        });

        window.onresize = function() {
          self.editInstance.ui.resizeEditor();
        };

        setTimeout(function() {
          document.querySelector('.tui-image-editor-header').style.display = 'none';
        }, 5);
      };

      self.editorSave = function() {
        self.savingExisting = true;
        function dataURItoBlob(dataURI) {
          var binary = atob(dataURI.split(',')[1]);
          var array = [];
          for(var i = 0; i < binary.length; i++) {
              array.push(binary.charCodeAt(i));
          }
          return new Blob([new Uint8Array(array)], {type: 'image/jpeg'});
        }

        var img = self.editInstance.toDataURL({format: 'jpeg'});
        var file = new File([dataURItoBlob(img)], 'uploaded-img.jpeg');

        self.settings.createLoading = true;
        self.settings.loading = true;
        self.imagePercent = 0;
        self.showEditor = false;
        S3Uploads.imagePolicy({fileName: file.name, contentType: file.type}, function(data) {
          var cloudFrontLink = data.CloudFrontLink;
          Upload.upload({
            url: 'https://' + data.Bucket + '.s3.amazonaws.com/',
            headers: {'Remove-auth': 'yes'},
            method: 'POST',
            data: {
              key: data.Key,
              'Content-Type': data.ContentType,
              AWSAccessKeyId: data.AWSAccessKeyId,
              'success_action_status': '201',
              policy: data.S3Policy,
              signature: data.S3Signature
            },
            file: file
          }).progress(function(evt) {
            var percent = parseInt(100.0 * evt.loaded / (evt.total * 0.05 + evt.total), 10);
            self.settings.percent = percent;
          }).success(function(data) {
            var link = cloudFrontLink;
            if (!link) {
              return;
            }


            self.image = link;
            self.settings.loading = false;
            self.settings.createLoading = false;
            self.settings.imageName = file.name;
            self.imageData.link = self.image;
            self.imageData.fileName = file.name;


            self.editorCancel();
            Application.scrollTop();
            self.savingExisting = false;
          }).catch(function(error) {
            console.log('upload error', error);
          });
        }, function(error) {
          console.log('s3url error', error);
          Application.messaging.addMessage({type: 'error', text: error.message, duration: 5});
        });
      };

      self.editorCancel = function() {
        self.showEditor = false;
        self.editType = null;
        self.editInstance = null;
      };

      self.editImage = function(type) {
        // Set timeouts are required to trick the watch
        if (type === 'banner') {
          self.bannerImage = '';
          setTimeout(function() {
            self.bannerImage = $scope.content.banner_image;
            $scope.$apply();
          }, 0);
          return;
        }

        self.coverImage = '';
        if (self.contentType === 'article' || self.contentType === 'imported_content' || self.contentType === 'event' || self.contentType === 'workshop' || self.contentType === 'presentation' || self.contentType === 'poll' || self.contentType === 'scorm') {
          setTimeout(function() {
            self.coverImage = $scope.content.image;
            $scope.$apply();
          }, 0);
          return;
        }

        setTimeout(function() {
          self.coverImage = $scope.content.images.explore;
          $scope.$apply();
        }, 0);
      };

      $scope.$watch('editSlide', function(newVal, oldVal) {
        if (newVal && newVal.content && (!oldVal || !self.image)) {
          self.image = newVal.content;
        }
      });

      $scope.$watch('presentationImage.settings.image', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }

        self.showEditor = true;
        setTimeout(function() {
          self.editInit(newVal);
        }, 5);
      });

      self.addImage = function() {
        $scope.add({image: self.imageData});
        self.image = null;
        self.imageData = {};
      };
      self.cancelImage = function() {
        self.image = null;
        self.imageData = {};
        $scope.cancel();
      };
    }],
    controllerAs: 'presentationImage'
  }
}]);